import React from 'react';
import { func } from 'prop-types';
import PageHeader from 'react-bootstrap/lib/PageHeader';
import Form from 'react-bootstrap/lib/Form';
import TextInput from '@coxautokc/fusion-ui-components/lib/TextInput';
import Button from '@coxautokc/fusion-ui-components/lib/Button';
import SelectInput from '@coxautokc/fusion-ui-components/lib/SelectInput';
import FuelSavingsResults from './FuelSavingsResults';
import { fuelSavings } from '../../../propTypes';

const FuelSavingsForm = ({ fuelSavings, onChange, onSaveClick }) => (
  <div>
    <PageHeader>Example: Redux App</PageHeader>
    <p>
      This example app uses React and Redux to calculate fuel savings. Review
      the code to see examples of how we recommend building React applications
      with Redux.
    </p>

    <p>
      <strong>Note</strong>: We don't recommend starting most new apps with
      Redux. Why? Because it's complicated, and many apps don't need it.
      Consider using{' '}
      <a href="https://reactjs.org/docs/context.html">
        React's built in context feature
      </a>{' '}
      instead. To see an example of context, check out App.js where we declare a
      context provider and Header.js where we consume it (to display the welcome
      message in the header).
    </p>
    <Form>
      <TextInput
        htmlId="FuelSavingsForm-NewMpg"
        onChange={onChange}
        label="New Vehicle MPG"
        name="newMpg"
        value={fuelSavings.newMpg}
      />
      <TextInput
        htmlId="FuelSavingsForm-TradeMpg"
        onChange={onChange}
        label="Trade-in MPG"
        name="tradeMpg"
        value={fuelSavings.tradeMpg}
      />
      <TextInput
        htmlId="FuelSavingsForm-NewPpg"
        onChange={onChange}
        label="New Vehicle price per gallon"
        name="newPpg"
        value={fuelSavings.newPpg}
      />
      <TextInput
        htmlId="FuelSavingsForm-TradeMpg"
        onChange={onChange}
        label="Trade-in price per gallon"
        name="tradePpg"
        value={fuelSavings.tradePpg}
      />
      <TextInput
        htmlId="FuelSavingsForm-MilesDriven"
        onChange={onChange}
        label="Miles Driven"
        name="milesDriven"
        value={fuelSavings.milesDriven}
      />
      <SelectInput
        htmlId="FuelSavingsForm-MilesPer"
        name="milesDrivenTimeframe"
        label="Miles Per"
        displayPlaceholder={false}
        onChange={onChange}
        value={fuelSavings.milesDrivenTimeframe}
        options={[
          { value: 'week', label: 'Week' },
          { value: 'month', label: 'Month' },
          { value: 'year', label: 'Year' }
        ]}
      />
      {fuelSavings.dateModified && 'Date Modified '} {fuelSavings.dateModified}{' '}
      <div>
        <Button
          htmlId="FuelSavingsForm-SaveMPG"
          data-test="save-mpg-button"
          bsStyle="primary"
          onClick={onSaveClick}
        >
          Save
        </Button>
      </div>
    </Form>

    {fuelSavings.necessaryDataIsProvidedToCalculateSavings && (
      <FuelSavingsResults savings={fuelSavings.savings} />
    )}
  </div>
);

FuelSavingsForm.propTypes = {
  fuelSavings: fuelSavings.isRequired,
  onChange: func.isRequired,
  onSaveClick: func.isRequired
};

export default FuelSavingsForm;



// WEBPACK FOOTER //
// ./src/components/pages/ReduxExamplePage/FuelSavingsForm.js